export default "__VITE_PUBLIC_ASSET__57262e4c__"